import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { getIconStyles as d } from "../styles.js";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: d(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_3922_22213)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8275 -0.0262721C12.209 -0.0702074 13.5843 0.177094 14.8639 0.699553C16.1435 1.22201 17.2989 2.00793 18.2548 3.00622C19.2108 4.0045 19.946 5.1928 20.4125 6.49385C20.5523 6.88375 20.3496 7.31318 19.9597 7.453C19.5698 7.59281 19.1404 7.39008 19.0006 7.00018C18.605 5.89726 17.9818 4.88992 17.1715 4.04366C16.3611 3.1974 15.3817 2.53116 14.2969 2.08826C13.2122 1.64537 12.0463 1.43573 10.8752 1.47297C9.70412 1.51021 8.55397 1.79351 7.49954 2.30444C6.44511 2.81537 5.51002 3.54249 4.75505 4.43854C4.00008 5.33458 3.44215 6.37948 3.11752 7.50531C2.79289 8.63114 2.70884 9.81268 2.87082 10.9731C3.03281 12.1336 3.43721 13.2469 4.05772 14.2408C4.1933 14.458 4.20875 14.7293 4.0987 14.9604L2.33516 18.6644L6.03912 16.9009C6.27006 16.7909 6.54112 16.8062 6.7582 16.9415C7.70608 17.5322 8.76308 17.9262 9.86633 18.1002C10.2755 18.1647 10.5549 18.5486 10.4904 18.9578C10.4259 19.367 10.0419 19.6464 9.63274 19.5819C8.46801 19.3982 7.34697 19.0067 6.32273 18.4272L1.07195 20.9272C0.785273 21.0637 0.443715 21.0049 0.219203 20.7803C-0.00530891 20.5558 -0.0641216 20.2143 0.0723698 19.9276L2.57221 14.6772C1.96027 13.598 1.55709 12.4117 1.38523 11.1805C1.19414 9.81159 1.2933 8.41779 1.67624 7.08972C2.05919 5.76165 2.71735 4.52904 3.60794 3.47203C4.49853 2.41502 5.6016 1.55728 6.84545 0.954565C8.08929 0.351851 9.44606 0.0176633 10.8275 -0.0262721Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.99953 6.75002C5.99953 6.3358 6.33532 6.00002 6.74953 6.00002H14.2495C14.6637 6.00002 14.9995 6.3358 14.9995 6.75002C14.9995 7.16423 14.6637 7.50002 14.2495 7.50002H6.74953C6.33532 7.50002 5.99953 7.16423 5.99953 6.75002Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.99953 11.25C5.99953 10.8358 6.33532 10.5 6.74953 10.5H9.74953C10.1637 10.5 10.4995 10.8358 10.4995 11.25C10.4995 11.6642 10.1637 12 9.74953 12H6.74953C6.33532 12 5.99953 11.6642 5.99953 11.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.3866 11.9773C19.6404 11.4985 18.7716 11.2459 17.885 11.25L17.8815 11.25L17.8785 11.25C17.2288 11.25 16.5863 11.3872 15.9932 11.6527C15.4002 11.9181 14.8699 12.3059 14.437 12.7905C14.0042 13.2751 13.6786 13.8457 13.4816 14.4648C13.2845 15.084 13.2205 15.7378 13.2936 16.3834C13.3668 17.0291 13.5755 17.652 13.906 18.2114C14.2366 18.7707 14.6816 19.254 15.2119 19.6295C15.7421 20.005 16.3457 20.2643 16.9832 20.3903C17.6206 20.5164 18.2774 20.5064 18.9107 20.361C19.1028 20.3169 19.3044 20.3502 19.4722 20.4536L21.5547 21.7376L21.1686 19.5143C21.1296 19.2897 21.1949 19.0596 21.3459 18.8889C21.9336 18.225 22.3166 17.4053 22.4487 16.5286C22.5808 15.6519 22.4564 14.7556 22.0906 13.9481C21.7247 13.1405 21.1329 12.456 20.3866 11.9773ZM17.8799 9.75002C19.0553 9.74497 20.2072 10.08 21.1966 10.7147C22.1865 11.3498 22.9715 12.2577 23.4569 13.329C23.9422 14.4003 24.1072 15.5891 23.932 16.7521C23.7751 17.7929 23.3517 18.7732 22.7057 19.5989L23.3175 23.1217C23.368 23.4124 23.2362 23.6705 22.9919 23.8359C22.7475 24.0013 22.4289 24.0081 22.1778 23.8532L18.9368 21.8857C18.1944 22.0162 17.4333 22.0084 16.6921 21.8618C15.8475 21.6948 15.0477 21.3512 14.345 20.8537C13.6423 20.3561 13.0527 19.7157 12.6147 18.9745C12.1766 18.2332 11.9001 17.4078 11.8032 16.5523C11.7063 15.6968 11.7911 14.8304 12.0522 14.01C12.3133 13.1895 12.7448 12.4334 13.3183 11.7913C13.8918 11.1491 14.5945 10.6353 15.3804 10.2836C16.1663 9.9318 17.0175 9.74999 17.8785 9.75002H17.8799Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.7495 14.25C15.7495 13.8358 16.0853 13.5 16.4995 13.5H19.4995C19.9137 13.5 20.2495 13.8358 20.2495 14.25C20.2495 14.6642 19.9137 15 19.4995 15H16.4995C16.0853 15 15.7495 14.6642 15.7495 14.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.7495 17.25C15.7495 16.8358 16.0853 16.5 16.4995 16.5H19.4995C19.9137 16.5 20.2495 16.8358 20.2495 17.25C20.2495 17.6642 19.9137 18 19.4995 18H16.4995C16.0853 18 15.7495 17.6642 15.7495 17.25Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_3922_22213", children: /* @__PURE__ */ C("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  r as ChatBubblesIcon
};
//# sourceMappingURL=ChatBubblesIcon.js.map
